import { Sparkles, Film, Mail } from "lucide-react";
import { useEffect } from "react";
import NewsletterSignup from "../components/NewsletterSignup";

export default function Newsletter() {
  useEffect(() => {
    document.title = "Newsletter · Christoreel";
    return () => { document.title = "Christoreel"; };
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 py-20" data-testid="newsletter-page">
      <div className="flex items-center gap-3 mb-4">
        <Sparkles className="h-4 w-4 text-[#E65F2B]" />
        <p className="text-eyebrow text-[#E65F2B]">Christoreel newsletter</p>
      </div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] mb-6">
        Faith-filled cinema, <span className="text-[#E65F2B]">delivered to your inbox.</span>
      </h1>
      <p className="text-lg text-white/60 mb-10 max-w-2xl leading-relaxed">
        A short letter from us, sent when we've something worth your time — new releases from African Christian filmmakers, featured channels, and stories from the artists behind the screen. No spam, unsubscribe with one click.
      </p>

      <div className="card-surface p-8 mb-10" data-testid="newsletter-cta-card">
        <div className="flex items-start gap-4 mb-6">
          <div className="h-11 w-11 rounded-lg flex items-center justify-center shrink-0 bg-[#E65F2B]/15 border border-[#E65F2B]/30">
            <Mail className="h-5 w-5 text-[#E65F2B]" />
          </div>
          <div>
            <p className="text-eyebrow text-[#E65F2B] mb-1">Free · every ~two weeks</p>
            <p className="font-display text-2xl font-bold">Join the list</p>
          </div>
        </div>
        <NewsletterSignup source="newsletter-page" variant="large" />
      </div>

      <div className="grid sm:grid-cols-3 gap-4 text-sm text-white/60">
        <div className="card-surface p-5">
          <Film className="h-5 w-5 text-[#EAB308] mb-3" />
          <p className="font-medium text-white mb-1">New films first</p>
          <p className="text-xs">Weekly picks from the platform, curated by our editors.</p>
        </div>
        <div className="card-surface p-5">
          <Sparkles className="h-5 w-5 text-[#EAB308] mb-3" />
          <p className="font-medium text-white mb-1">Filmmaker stories</p>
          <p className="text-xs">Interviews and behind-the-scenes from creators across Africa.</p>
        </div>
        <div className="card-surface p-5">
          <Mail className="h-5 w-5 text-[#EAB308] mb-3" />
          <p className="font-medium text-white mb-1">One-click unsubscribe</p>
          <p className="text-xs">Every email has an unsubscribe link. We never share your address.</p>
        </div>
      </div>
    </div>
  );
}
